var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 16",
    style: {
      enableBackground: "new 0 0 20 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n\t.st2{clip-path:url(#SVGID_00000023256615781067136080000001847050693824181646_);}\r\n\t.st3{clip-path:url(#SVGID_00000034776458971580113500000002213954007833338268_);}\r\n\t.st4{fill:#F2F2F2;}\r\n\t.st5{fill:#BDB6B8;}\r\n\t.st6{fill:#1A1A1A;}\r\n\t.st7{fill:#ADA8AA;}\r\n\t.st8{fill:#262424;}\r\n\t.st9{fill:#1E8273;}\r\n\t.st10{fill:#239281;}\r\n\t.st11{fill:#262626;}\r\n\t.st12{fill:#0F0F0F;}\r\n\t.st13{fill:#212226;}\r\n\t.st14{opacity:0.25;}\r\n\t.st15{clip-path:url(#SVGID_00000103238131674822028150000005334746141986016932_);}\r\n\t.st16{opacity:0.15;}\r\n\t.st17{clip-path:url(#SVGID_00000178894328984047419650000010611328267474535826_);}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_45_00000070827678955372675450000004029467003067521975_",
    className: "st0",
    d: "M18,0H2C0.9,0,0,0.9,0,2l0,12 c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V2C20,0.9,19.1,0,18,0z M17.6,4.2l-7.1,4.4c-0.3,0.2-0.7,0.2-1.1,0L2.4,4.2C2,4,1.9,3.5,2.1,3.1 s0.8-0.5,1.2-0.3L10,7l6.7-4.2c0.4-0.2,0.9-0.1,1.2,0.3C18.1,3.5,18,4,17.6,4.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmail);
export default __webpack_public_path__ + "static/media/icon_email.dfba1bc6d9543185621659744d6d6f79.svg";
export { ForwardRef as ReactComponent };